export const promisifyAction = action => (...args) => new Promise((resolve, reject) => action(
  {
    onSuccess: resolve,
    onFail: reject,
  },
  ...args
));
